import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { HiMenuAlt3 } from "react-icons/hi";
import { RxCross2 } from "react-icons/rx";
import { LuUsers } from "react-icons/lu";
import { TbReportAnalytics } from "react-icons/tb";
import { MdOutlineDashboard } from "react-icons/md";
import { VscGraph } from "react-icons/vsc";
import Tata from "../../assets/images/tatamotorswhite.png"
import vehicleImage from "../../assets/images/vehicle360.png";
import spaqplug from "../../assets/images/spaqplug_logo.png";
import { IoHome } from "react-icons/io5";
import logocompany from "../../assets/landingPageImg/logotatacompany.svg"


function Header({ title, heading }) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [submenuOpenIndex, setSubmenuOpenIndex] = useState(null);
  const arn = "someArn"; // example value

  const navigate = useNavigate();

  const availableMenus = {
    "Home": {
      name: "Home",
      icon: IoHome,
      subMenu: [],
      link: "/home",
    },

    "Customer 360": {
      name: "Customer 360",
      icon: LuUsers,
      subMenu: [
        { name: "Pipeline & Financials", link: "/piplineAndService" },
        { name: "Service & Spares", link: "/Services" },
        { name: "Complaints", link: "/complaints" },
        { name: "FleetEdge", link: "/fleetEdge" },
        { name: "Vehicle", link: "/Vehicle" },
        { name: "Fleet Insights", link: "/fleet-insigths" },
        { name: "Complaint Tat", link: "/complaint-tat" },
      ],
      disabled: arn === "",
    },
    "ARN Enrichment": {
      name: "ARN Enrichment",
      icon: TbReportAnalytics,
      subMenu: [
        { name: "Creator", link: "/arnenrichment" },
        { name: "Approver", link: "/approver" },
      ],
    },
    "Anomaly Detection": {
      name: "Anomaly Detection",
      icon: MdOutlineDashboard,
      subMenu: [],
      link: "/anomaly",
    },
    "VAS Dashboard": {
      name: "VAS Dashboard",
      icon: VscGraph,
      subMenu: [],
      link: "/vas-dashboard",
    },
    "Vehicle 360": {
      name: "Vehicle 360",
      icon: () => (
        <img
          src={vehicleImage}
          alt="Vehicle 360"
          style={{ width: "20px", height: "20px" }}
        />
      ),
      link: "https://vehicle360cv.infoportal.tatamotors.com/search",
      subMenu: [],
    },
  };

  const toggleSubmenu = (index) => {
    setSubmenuOpenIndex(submenuOpenIndex === index ? null : index);
  };

  const renderMenuItems = () => {
    return Object.entries(availableMenus).map(([key, menuItem], index) => (
      <div key={index}>
        <div
          className={`flex  items-center justify-between p-3 cursor-pointer hover:bg-blue-600 rounded ${menuItem.disabled ? "opacity-50 cursor-not-allowed" : ""
            }`}
          onClick={() => {
            if (!menuItem.disabled && menuItem.subMenu.length > 0) {
              toggleSubmenu(index);
            } else if (menuItem.link) {
              navigate(menuItem.link);
              setMobileOpen(false);
            }
          }}
        >
          <div className="flex items-center gap-2">
            {typeof menuItem.icon === "function" &&
              menuItem.icon.prototype?.isReactComponent ? (
              <menuItem.icon className="text-white" />
            ) : typeof menuItem.icon === "function" ? (
              menuItem.icon()
            ) : (
              <menuItem.icon className="text-white" />
            )}
            <span>{menuItem.name}</span>
          </div>
          {menuItem.subMenu.length > 0 && (
            <span className="text-white select-none">
              {submenuOpenIndex === index ? "▼" : "▶"}
            </span>
          )}
        </div>

        {submenuOpenIndex === index && menuItem.subMenu.length > 0 && (
          <div className="pl-6 bg-[linear-gradient(90deg,#055096_0%,#4EB0E2_100%)]">
            {menuItem.subMenu.map((subItem, subIndex) => (
              <div
                key={subIndex}
                className="block p-2 text-white hover:bg-blue-600 cursor-pointer"
                onClick={() => {
                  navigate(subItem.link);
                  setMobileOpen(false);
                }}
              >
                {subItem.name}
              </div>
            ))}
          </div>
        )}
      </div>
    ));
  };

  return (
    <div className="w-full">

      {/* HEADER */}
      <div className="bg-[linear-gradient(0deg,#055096_0%,#4EB0E2_100%)] text-white min-w-full w-full h-[54px]">
        <header className="flex w-full items-center justify-between px-4 py-2 relative">
          {/* Left side */}
          <div className="flex items-center gap-2">
            {/* Menu icon on mobile */}
            {/* <HiMenuAlt3
              size={28}
              className="cursor-pointer md:hidden"
              onClick={() => setMobileOpen(true)}
            /> */}
            {/* Logo on desktop */}

            {/* <img src={Tata} alt="Tata Motors" className="hidden md:block w-32" /> */}
          </div>
          <img src={logocompany} className=" w-32" />
          {/* Center */}
          <h1 className="text-lg font-semibold text-center pl-4 flex-1">
            {heading || title || "Customer 360"}
          </h1>
          <img src={spaqplug} className="hidden md:block w-12 h-10" alt="Spaqplug" />

          {/* Right side */}
          <div className="flex items-center">
            {/* Logo on mobile */}
            <img src={Tata} alt="Tata Motors" className="w-20 md:hidden" />
          </div>
        </header>
      </div>

      {/* SLIDER MENU */}
      <nav
        className={`fixed top-0 left-0 h-full w-64 z-50 transform transition-transform duration-300 overflow-auto shadow-lg ${mobileOpen ? "translate-x-0" : "-translate-x-full"
          } bg-[linear-gradient(90deg,#055096_0%,#4EB0E2_100%)] text-white`}
      >
        <div className="flex justify-between items-center p-4">
          <RxCross2
            size={28}
            className="cursor-pointer"
            onClick={() => setMobileOpen(false)}
          />
        </div>
        <div>{renderMenuItems()}</div>
      </nav>
    </div>

  );
}

export default Header;
